import React, { useState, useCallback } from "react";
import styles from "./styles.module.scss";
import { linkConfig } from "../../config";
import { parse } from "qs";
import { useLocation } from 'react-router-dom';
import Utils from "../../utils";

const { downloadNow } = Utils
export default () => {

  const location = useLocation();
  const params = parse(location.search.slice(1));

  const [state, setState] = useState(true);

  const toggle = useCallback(() => {
    setState(!state);
  }, [state]);

  return state ? (
    <div className={styles.bar}>
      <div className="close" onClick={toggle}></div>
      <div>
        <strong>安东环球</strong>
        下载APP领<span> $6000 </span>赠金
      </div>
      <a onClick={downloadNow} target="_blank">
        立即下载
      </a>
    </div>
  ) : (
    ""
  );
};